export const FIND_PROCESS_STATEMENTS_FAILURE = 'FIND_PROCESS_STATEMENTS_FAILURE';

export const findProcessStatementsFailure = error => ({
    type: FIND_PROCESS_STATEMENTS_FAILURE,
    payload: error,
    error: true,
});
